import { render } from "./RemoveMenuItem.vue?vue&type=template&id=b9d4cb5e"
import script from "./RemoveMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoveMenuItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/RemoveMenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b9d4cb5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b9d4cb5e', __exports__)) {
    api.reload('b9d4cb5e', __exports__)
  }
  
  module.hot.accept("./RemoveMenuItem.vue?vue&type=template&id=b9d4cb5e", () => {
    api.rerender('b9d4cb5e', render)
  })

}


export default __exports__